import { Dialog, DialogTitle } from '@mui/material'
import React, { useCallback, useState } from 'react'

import { useUpdateCannedJobDate } from '../../../hooks'
import { CannedJobMotorFluidsEntry } from '../../../sdk'
import { LookupMotorFluidsWindow } from './LookupMotorFluidsWindow'

export const useAddMotorFluidsDialog = () => {
  const { updateDate } = useUpdateCannedJobDate()
  const [customProps, setCustomProps] = useState<
    | {
        cannedJobId: string
        existingEntry: CannedJobMotorFluidsEntry | undefined
      }
    | undefined
  >()
  const cancelCallback = useCallback(() => {
    setCustomProps(undefined)
  }, [])
  const submitCallback = useCallback(() => {
    setCustomProps(undefined)
    updateDate()
  }, [updateDate])

  const AddMotorFluidsDialog = useCallback(() => {
    return (
      <>
        {customProps && (
          <Dialog open={true} fullWidth={true} maxWidth={'md'}>
            <DialogTitle data-testid="dialogTitle">
              Search for Fluids Items
            </DialogTitle>
            <LookupMotorFluidsWindow
              cancelCallback={cancelCallback}
              submitCallback={submitCallback}
              {...customProps}
            />
          </Dialog>
        )}
      </>
    )
  }, [cancelCallback, customProps, submitCallback])

  return { setCustomProps, AddMotorFluidsDialog }
}
